/* eslint-disable */
import React from 'react'

export class CreateLinkIcon extends React.Component {
  render() {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.56974 1.23201C10.2901 -0.431258 13.025 -0.407456 14.7162 1.28547C16.4071 2.978 16.4308 5.71441 14.7696 7.43609L14.7608 7.4451L12.5667 9.64143C11.6674 10.5419 10.4215 11.0072 9.15245 10.9162C7.88336 10.8253 6.71654 10.187 5.9547 9.16751C5.71427 8.84575 5.78019 8.39001 6.10194 8.14958C6.4237 7.90915 6.87944 7.97507 7.11987 8.29682C7.62915 8.97835 8.40884 9.40465 9.25646 9.46542C10.1041 9.52618 10.9364 9.21546 11.5374 8.61361L11.5375 8.61352L13.727 6.42182C14.8335 5.27048 14.8162 3.44364 13.6872 2.31347C12.5583 1.18346 10.734 1.16644 9.58434 2.27429L8.33026 3.52234C8.04555 3.80567 7.58507 3.80456 7.30174 3.51985C7.01841 3.23515 7.01952 2.77467 7.30422 2.49133L8.56223 1.23938L8.56974 1.23201Z"
          fill="#CCCCCC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.43353 6.35846C4.3328 5.45801 5.5786 4.99276 6.84766 5.08374C8.11675 5.17472 9.28357 5.81296 10.0454 6.83248C10.2858 7.15423 10.2199 7.60997 9.89816 7.8504C9.57641 8.09084 9.12067 8.02491 8.88024 7.70316C8.37096 7.02163 7.59127 6.59533 6.74365 6.53456C5.89604 6.4738 5.06369 6.78452 4.46266 7.38637L2.27307 9.57817C1.16662 10.7295 1.18388 12.5563 2.31291 13.6865C3.44155 14.8163 5.2653 14.8335 6.41505 13.7264L7.66104 12.4791C7.94491 12.195 8.40539 12.1948 8.68956 12.4786C8.97372 12.7625 8.97395 13.223 8.69007 13.5071L7.43938 14.7591L7.43037 14.768C5.70999 16.4312 2.97509 16.4074 1.28387 14.7145C-0.406963 13.022 -0.430705 10.2856 1.23047 8.5639L1.23932 8.55488L3.43353 6.35846C3.4335 6.35849 3.43356 6.35843 3.43353 6.35846Z"
          fill="#CCCCCC"
        />
      </svg>
    )
  }
}

export const NoChartDataIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M49.3334 0H4C1.79087 0 0 1.79088 0 4.00002V36.0001C0 38.2093 1.79087 40.0002 4 40.0002H21.3334V37.3335H4C3.26362 37.3335 2.66662 36.7365 2.66662 36.0001V4.00002C2.66662 3.26364 3.26362 2.66664 4 2.66664H49.3334C50.0697 2.66664 50.6667 3.26364 50.6667 4.00002V28.0001H53.3334V4.00002C53.3334 1.79088 51.5425 0 49.3334 0Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path d="M18.6666 38.667H16V46.667H18.6666V38.667Z" fill="var(--color-spun-pearl-grey)" />
    <path
      d="M9.33423 32C8.59785 32 8.00085 31.403 8.00085 30.6666V28H5.33423V30.6666C5.33423 32.8758 7.1251 34.6667 9.33423 34.6667H12.0009V32H9.33423Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path d="M8.00085 22.667H5.33423V25.3336H8.00085V22.667Z" fill="var(--color-spun-pearl-grey)" />
    <path
      d="M48.7292 28.2421C46.0122 25.5246 42.3268 23.9979 38.484 23.998C30.4833 23.9984 23.9977 30.4846 23.9979 38.4854C23.9983 46.4861 30.4844 52.9718 38.4852 52.9715C42.3267 52.9714 46.0107 51.4455 48.7273 48.7294C54.3852 43.0725 54.386 33.9001 48.7292 28.2421ZM38.4772 50.3062C31.9492 50.3039 26.6589 45.0101 26.6612 38.4821C26.6634 31.9541 31.9572 26.6638 38.4852 26.6661C41.6228 26.6576 44.6332 27.9061 46.8438 30.1327C49.0585 32.35 50.3022 35.3561 50.3012 38.4901C50.2989 45.0181 45.0052 50.3084 38.4772 50.3062Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M63.6099 57.9995L55.2405 49.6328C54.9905 49.3828 54.6514 49.2422 54.2979 49.2422C53.9442 49.2423 53.6052 49.3828 53.3552 49.6328L49.6352 53.3528C49.1147 53.8735 49.1147 54.7175 49.6352 55.2382L58.0046 63.6089C58.2546 63.859 58.5937 63.9995 58.9472 63.9995C59.3014 63.9984 59.6406 63.8564 59.8899 63.6049L63.6099 59.8849C64.1304 59.3641 64.1304 58.5201 63.6099 57.9995ZM58.9471 60.7809L52.4631 54.2955L54.2977 52.4608L60.7817 58.9462L58.9471 60.7809Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M48.7291 46.84L46.8435 48.7256L51.4934 53.3755L53.379 51.4899L48.7291 46.84Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M38.6667 29.333V31.9996C42.3469 32.004 45.329 34.9863 45.3334 38.6663H48C47.9942 33.5141 43.819 29.3389 38.6667 29.333Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path d="M24.0008 45.335H13.3342V48.0016H24.0008V45.335Z" fill="var(--color-spun-pearl-grey)" />
    <path
      d="M20 5.33301C17.7909 5.33301 16 7.12389 16 9.33302C16 11.5422 17.7909 13.333 20 13.333C22.2091 13.333 24 11.5422 24 9.33302C24 7.12389 22.2091 5.33301 20 5.33301ZM20 10.6663C19.2636 10.6663 18.6666 10.0693 18.6666 9.3329C18.6666 8.59652 19.2636 7.99952 20 7.99952C20.7364 7.99952 21.3334 8.59652 21.3334 9.3329C21.3334 10.0694 20.7364 10.6663 20 10.6663Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M29.3341 14.667C27.125 14.667 25.3341 16.4579 25.3341 18.667C25.3341 20.8761 27.125 22.667 29.3341 22.667C31.5432 22.667 33.3341 20.8761 33.3341 18.667C33.3341 16.4579 31.5432 14.667 29.3341 14.667ZM29.3341 20.0004C28.5977 20.0004 28.0007 19.4034 28.0007 18.667C28.0007 17.9306 28.5977 17.3336 29.3341 17.3336C30.0705 17.3336 30.6675 17.9306 30.6675 18.667C30.6674 19.4034 30.0705 20.0004 29.3341 20.0004Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M17.7232 9.72406L11.0566 16.3906L12.9422 18.2762L19.6087 11.6096L17.7232 9.72406Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M22.2698 9.72477L20.3843 11.6104L27.0508 18.2769L28.9364 16.3913L22.2698 9.72477Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M38.6667 5.33301C36.4576 5.33301 34.6667 7.12389 34.6667 9.33302C34.6667 11.5422 36.4576 13.333 38.6667 13.333C40.8759 13.333 42.6667 11.5422 42.6667 9.33302C42.6669 7.12389 40.876 5.33301 38.6667 5.33301ZM38.6667 10.6663C37.9304 10.6663 37.3334 10.0693 37.3334 9.3329C37.3334 8.59652 37.9304 7.99952 38.6667 7.99952C39.4031 7.99952 40.0001 8.59652 40.0001 9.3329C40.0001 10.0694 39.4031 10.6663 38.6667 10.6663Z"
      fill="var(--color-spun-pearl-grey)"
    />
    <path
      d="M36.3909 9.72992L29.7244 16.3965L31.6099 18.2821L38.2765 11.6155L36.3909 9.72992Z"
      fill="var(--color-spun-pearl-grey)"
    />
  </svg>
)

export class BroadcastIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 22 18" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 9.03027C8 7.37342 9.34315 6.03027 11 6.03027C12.6569 6.03027 14 7.37342 14 9.03027C14 10.6871 12.6569 12.0303 11 12.0303C9.34315 12.0303 8 10.6871 8 9.03027ZM11 8.03027C10.4477 8.03027 10 8.47799 10 9.03027C10 9.58256 10.4477 10.0303 11 10.0303C11.5523 10.0303 12 9.58256 12 9.03027C12 8.47799 11.5523 8.03027 11 8.03027Z"
          fill={this.props.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.63682 1.25275C5.0274 1.64321 5.0275 2.27638 4.63703 2.66696C1.12359 6.18146 1.12359 11.8785 4.63703 15.393C5.0275 15.7835 5.0274 16.4167 4.63682 16.8072C4.24623 17.1976 3.61307 17.1975 3.2226 16.807C-1.0716 12.5115 -1.0716 5.54846 3.2226 1.25296C3.61307 0.862378 4.24623 0.862282 4.63682 1.25275ZM17.3628 1.25275C17.7534 0.862282 18.3866 0.862378 18.777 1.25296C23.0712 5.54846 23.0712 12.5115 18.777 16.807C18.3866 17.1975 17.7534 17.1976 17.3628 16.8072C16.9722 16.4167 16.9721 15.7835 17.3626 15.393C20.876 11.8785 20.876 6.18146 17.3626 2.66696C16.9721 2.27638 16.9722 1.64321 17.3628 1.25275ZM7.46722 4.07356C7.85753 4.4643 7.85717 5.09747 7.46643 5.48777C6.52755 6.42561 6 7.69823 6 9.02527C6 10.3523 6.52755 11.6249 7.46643 12.5628C7.85717 12.9531 7.85753 13.5862 7.46722 13.977C7.07691 14.3677 6.44375 14.3681 6.05301 13.9778C4.73857 12.6648 4 10.8831 4 9.02527C4 7.16741 4.73857 5.38575 6.05301 4.07277C6.44375 3.68247 7.07691 3.68282 7.46722 4.07356ZM14.5327 4.08137C14.923 3.69063 15.5562 3.69028 15.9469 4.08059C17.2614 5.39356 18 7.17522 18 9.03309C18 10.891 17.2614 12.6726 15.9469 13.9856C15.5562 14.3759 14.923 14.3755 14.5327 13.9848C14.1424 13.5941 14.1428 12.9609 14.5335 12.5706C15.4724 11.6327 16 10.3601 16 9.03309C16 7.70604 15.4724 6.43343 14.5335 5.49559C14.1428 5.10528 14.1424 4.47211 14.5327 4.08137Z"
          fill={this.props.color}
        />
      </svg>
    )
  }
}

export class Chevron extends React.Component {
  render() {
    return (
      <svg
        width="11"
        height="7"
        viewBox="0 0 11 7"
        fill="none"
        className={this.props.classes}
        style={
          this.props.rotate
            ? {
              transform: 'rotate(180deg)',
            }
            : {}
        }>
        <path
          d="M1 1L5.5 6L10 1"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DashboardIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 22 22" fill="none">
        <path
          d="M10 0L0 5L10 10L20 5L10 0V0Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L10 5L20 0"
          transform="translate(1 16)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L10 5L20 0"
          transform="translate(1 11)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class FlowsIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 21 21" fill="none">
        <path
          d="M0 0H5V5"
          transform="translate(13.8691 1.95015) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 17L17 0"
          transform="translate(1.87036 2.12434) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 0V5H0"
          transform="translate(14.0579 14.9488) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L6 6"
          transform="translate(13.0435 13.9634) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L5 5"
          transform="translate(1.88477 3.12424) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class NlpIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 22 22" fill="none">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
          transform="translate(5 5)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
          transform="translate(9 9)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class UsersIcon extends React.Component {
  render() {
    return (
      <svg
        className="menu_fill-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none">
        <g clipPath="url(#clip0_4683_5284)">
          <path
            d="M12 0.630371C5.71395 0.630371 0.599976 5.74435 0.599976 12.0304C0.599976 18.3164 5.71395 23.4304 12 23.4304C18.286 23.4304 23.4 18.3164 23.4 12.0304C23.4 5.74435 18.286 0.630371 12 0.630371ZM18.9201 18.8976C18.046 17.1 16.2032 15.8594 14.0708 15.8594H9.92917C7.79676 15.8594 5.95395 17.1 5.07983 18.8976C3.32902 17.1335 2.24534 14.7063 2.24534 12.0304C2.24534 6.65162 6.62134 2.27573 12 2.27573C17.3786 2.27573 21.7546 6.65162 21.7546 12.0304C21.7546 14.7063 20.6709 17.1335 18.9201 18.8976Z"
            fill={this.props.color}
          />
          <path
            d="M12 14.2218C14.4207 14.2218 16.3831 12.2594 16.3831 9.83869C16.3831 7.41796 14.4207 5.45557 12 5.45557C9.57927 5.45557 7.61688 7.41796 7.61688 9.83869C7.61688 12.2594 9.57927 14.2218 12 14.2218Z"
            fill={this.props.color}
          />
        </g>
      </svg>
    )
  }
}

export class ServiceUsersIcon extends React.Component {
  render() {
    return (
      <svg
        className="menu_fill-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M21.9862 2.75641C19.2139 -0.0316116 14.6385 0.106982 11.9989 3.00502C9.35909 0.107084 4.78387 -0.0316628 2.0115 2.75646C-0.745388 5.50196 -0.65147 10.023 2.18907 12.6728C0.735846 14.0608 1.56838 16.5548 3.54638 16.798C3.4279 18.1524 4.5807 19.3945 5.94432 19.3714C6.02793 20.8625 7.52445 21.9298 8.95921 21.5357C9.42992 23.3121 11.6927 23.9191 12.9909 22.6117C13.7282 21.8788 14.3145 21.4167 14.3519 20.3067C15.5701 20.2727 16.6242 19.2044 16.6428 17.9868C17.8727 17.9678 18.9443 16.8959 18.9633 15.6663C20.2392 15.6469 21.3455 14.4953 21.2862 13.1952L21.9861 12.4953C24.6712 9.81024 24.6712 5.44138 21.9862 2.75641ZM3.24453 13.7935L3.902 13.1361C4.07193 12.9661 4.29505 12.8812 4.51828 12.8812C5.28367 12.8761 5.68319 13.8224 5.13446 14.3685L4.47699 15.026C3.62594 15.8095 2.46093 14.6449 3.24453 13.7935ZM5.07778 16.9624C5.07778 16.7296 5.16847 16.5107 5.33307 16.3461L5.99089 15.6883C6.15544 15.524 6.37416 15.4334 6.60677 15.4334C7.37867 15.4321 7.76994 16.3762 7.223 16.9212L6.64288 17.5013C6.46556 17.7023 6.22197 17.8382 5.94925 17.8339C5.48089 17.8435 5.06809 17.4309 5.07778 16.9624ZM7.73095 19.8218C7.39288 19.4974 7.39288 18.9137 7.73095 18.5894L8.31107 18.0092C8.6493 17.6077 9.24306 17.5554 9.62094 17.9318C9.9607 18.2717 9.9607 18.8244 9.62094 19.1643L8.96342 19.8218C8.62365 20.1617 8.07077 20.1617 7.73095 19.8218ZM12.5603 20.8661L11.9029 21.5236C11.7383 21.6882 11.5194 21.7789 11.2866 21.7789C11.0538 21.7789 10.8349 21.6882 10.6703 21.5236C10.3323 21.1992 10.3322 20.6155 10.6704 20.2912L11.3278 19.6337C11.6676 19.2939 12.2205 19.2939 12.5603 19.6336C12.8984 19.9581 12.8984 20.5417 12.5603 20.8661ZM19.493 13.8755C19.1686 14.2135 18.5849 14.2136 18.2605 13.8755L14.8364 10.4513L13.7483 11.5394L17.1725 14.9635C17.5122 15.3033 17.5122 15.8562 17.1725 16.196C16.8327 16.5359 16.2798 16.5358 15.94 16.196L12.5739 12.8299L12.5159 12.7718L11.4278 13.8599L11.4858 13.918L14.8519 17.2841C15.1917 17.6239 15.1917 18.1768 14.8519 18.5166C14.5121 18.8564 13.9592 18.8564 13.6194 18.5166L13.6188 18.5172C12.9935 17.9128 12.1198 17.7138 11.3306 17.9202C11.0793 16.8936 10.0474 16.1164 9.00963 16.1391C8.95931 15.0341 8.02517 14.0359 6.92124 13.9167C7.06692 12.0209 4.98484 10.7154 3.34172 11.6492C1.05335 9.60512 0.912396 6.01673 3.09967 3.84448C5.27439 1.65454 8.86765 1.79964 10.9109 4.0931L9.00866 5.99534L10.5329 7.51961C11.7038 8.69057 13.5081 8.85168 14.8533 8.0031L19.4932 12.643C19.8328 12.9828 19.8328 13.5356 19.493 13.8755ZM20.8982 11.4072L20.6637 11.6416C20.637 11.6122 20.6094 11.5832 20.5811 11.5549L14.9138 5.88753L14.3697 6.43154C13.6119 7.18934 12.3788 7.18944 11.6209 6.43154L11.1847 5.99534L13.3356 3.84448C18.5603 -0.964371 25.706 6.18584 20.8982 11.4072Z"
          fill={this.props.color}
        />
      </svg>
    )
  }
}

export class SupportIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 20 20" fill="none">
        <path
          d="M18 12C18 13.1046 17.1046 14 16 14H4L0 18V2C0 0.89543 0.89543 0 2 0H16C17.1046 0 18 0.89543 18 2V12Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class WidgetIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.4464 16.0837L16.3864 11.0303L20.9998 6.42367C21.4284 5.99486 21.6693 5.41334 21.6693 4.80701C21.6693 4.20067 21.4284 3.61915 20.9998 3.19034L18.8398 1.03034C18.4109 0.601658 17.8294 0.36084 17.2231 0.36084C16.6168 0.36084 16.0352 0.601658 15.6064 1.03034L10.9998 5.64367L5.94643 0.590338C5.87576 0.518984 5.79165 0.462342 5.69897 0.423686C5.60628 0.385031 5.50685 0.365128 5.40643 0.365128C5.306 0.365128 5.20657 0.385031 5.11389 0.423686C5.0212 0.462342 4.93709 0.518984 4.86643 0.590338L0.553093 4.89701C0.481739 4.96767 0.425097 5.05178 0.386441 5.14446C0.347786 5.23715 0.327883 5.33658 0.327883 5.43701C0.327883 5.53743 0.347786 5.63686 0.386441 5.72955C0.425097 5.82223 0.481739 5.90634 0.553093 5.97701L5.61309 11.0303L2.21976 14.4237C1.67566 14.9684 1.31054 15.6661 1.17309 16.4237L0.333093 20.797C0.311773 20.9166 0.319412 21.0395 0.35537 21.1555C0.391327 21.2715 0.454556 21.3771 0.53976 21.4637C0.625968 21.5496 0.731398 21.6138 0.847325 21.6509C0.963253 21.688 1.08635 21.6969 1.20643 21.677L5.57976 20.857C6.33798 20.7173 7.03563 20.3499 7.57976 19.8037L10.9998 16.417L16.0531 21.4703C16.1975 21.6112 16.3913 21.6901 16.5931 21.6901C16.7949 21.6901 16.9887 21.6112 17.1331 21.4703L21.4464 17.157C21.5885 17.0145 21.6683 16.8215 21.6683 16.6203C21.6683 16.4191 21.5885 16.2261 21.4464 16.0837ZM16.6864 2.08367C16.8309 1.94278 17.0247 1.86391 17.2264 1.86391C17.4282 1.86391 17.622 1.94278 17.7664 2.08367L19.9198 4.23701C20.0622 4.38061 20.1422 4.57471 20.1422 4.77701C20.1422 4.9793 20.0622 5.1734 19.9198 5.31701L18.2264 7.03034L14.9998 3.80367L16.6864 2.08367ZM2.17309 5.41701L5.40643 2.20367L6.69309 3.49034L6.15476 4.02535C5.85588 4.32239 5.85513 4.80571 6.15309 5.10367C6.45106 5.40164 6.93438 5.40089 7.23142 5.102L7.76643 4.56367L9.91976 6.71701L6.68643 9.95034L2.17309 5.41701ZM6.52643 18.717C6.20202 19.0442 5.78586 19.265 5.33309 19.3503L2.05309 19.9637L2.66643 16.697C2.74948 16.2449 2.96803 15.8287 3.29309 15.5037L13.9131 4.88367L17.1464 8.11701L6.52643 18.717ZM16.5931 19.837L12.0731 15.317L15.3064 12.0837L17.4598 14.237L16.9198 14.777C16.6215 15.0752 16.6215 15.5588 16.9198 15.857C17.218 16.1552 17.7015 16.1552 17.9998 15.857L18.5398 15.317L19.8264 16.6037L16.5931 19.837Z"
          fill={this.props.color}
        />
        stroke={this.props.color}
      </svg>
    )
  }
}

export class SettingsIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 24 20" fill="none">
        <path
          d="M0 7V0"
          transform="translate(4 12)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 7V0"
          transform="translate(4 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 9V0"
          transform="translate(12 10)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 5V0"
          transform="translate(12 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 5V0"
          transform="translate(20 14)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 9V0"
          transform="translate(20 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H6"
          transform="translate(1 12)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H6"
          transform="translate(9 6)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H6"
          transform="translate(17 14)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const AnalyticsIcon = props => {
  return (
    <svg width={props.width} height={props.height} viewBox="0 0 24 24" fill="none">
      <path
        d="M23 6L13.5 15.5L8.5 10.5L1 18"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17 6H23V12" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export class PlusIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 13 13" fill="none">
        <path
          d="M0 0V11"
          transform="translate(6.5 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H11"
          transform="translate(1 6.5)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class CloseIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 9 9" fill="none">
        <path
          d="M7 0L0 7"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L7 7"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class SearchIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 20 20" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.2 5.2L0 0"
          transform="translate(13.8 13.8)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class TextIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 16 13" fill="none">
        <path
          d="M9.68406 0H0"
          transform="translate(2.9884 4.24988)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9192 0H0"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9192 0H0"
          transform="translate(1 7.19226)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.68406 0H0"
          transform="translate(2.9884 10.1345)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ListIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 13 13" fill="none">
        <path
          d="M0 0H11"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H11"
          transform="translate(1 6.21143)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H11"
          transform="translate(1 11.1154)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class GalleryIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 12 15" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.89543 0.89543 0 2 0H7.94231C9.04688 0 9.94231 0.895431 9.94231 2V9.76923C9.94231 10.8738 9.04688 11.7692 7.94231 11.7692H2C0.895431 11.7692 0 10.8738 0 9.76923V2Z"
          transform="translate(10.9423 13.0769) rotate(180)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class AttachmentIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 19 11" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7558 0H13.0606C14.0794 0 15.0565 0.413323 15.7768 1.14904C16.4972 1.88476 16.902 2.88261 16.902 3.92308C16.902 6.08973 15.1821 7.84615 13.0606 7.84615H10.7558V0ZM6.14615 7.84615H3.84135C2.82256 7.84615 1.8455 7.43283 1.1251 6.69711C0.404712 5.96139 0 4.96354 0 3.92308C0 1.75642 1.71983 0 3.84135 0H6.14615V7.84615Z"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H5.96538"
          transform="translate(5.97113 5.23071)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ReplyIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 19 14" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5.39423C0 2.41508 2.41508 0 5.39423 0H11.5077C14.4868 0 16.9019 2.41508 16.9019 5.39423V5.39423C16.9019 8.37338 14.4868 10.7885 11.5077 10.7885H5.39423C2.41508 10.7885 0 8.37338 0 5.39423V5.39423Z"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class OtherIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 19 6" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.49135 2.94231C2.31499 2.94231 2.98269 2.28365 2.98269 1.47115C2.98269 0.658658 2.31499 0 1.49135 0C0.667698 0 0 0.658658 0 1.47115C0 2.28365 0.667698 2.94231 1.49135 2.94231Z"
          transform="translate(7.95959 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.49135 2.94231C2.31499 2.94231 2.98269 2.28365 2.98269 1.47115C2.98269 0.658658 2.31499 0 1.49135 0C0.667698 0 0 0.658658 0 1.47115C0 2.28365 0.667698 2.94231 1.49135 2.94231Z"
          transform="translate(14.9193 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.49135 2.94231C2.31499 2.94231 2.98269 2.28365 2.98269 1.47115C2.98269 0.658658 2.31499 0 1.49135 0C0.667698 0 0 0.658658 0 1.47115C0 2.28365 0.667698 2.94231 1.49135 2.94231Z"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DoneIcon extends React.Component {
  render() {
    return (
      <svg width="18" height="13" viewBox="0 0 18 13" fill="none">
        <path
          d="M16 0L5 11L0 6"
          transform="translate(1 1)"
          stroke={this.props.color ? this.props.color : 'var(--color-malachite-green)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class LeftArrowIcon extends React.Component {
  render() {
    return (
      <svg width="7" height="11" viewBox="0 0 7 11" fill="none">
        <path
          d="M0 0L4.5 5L9 0"
          transform="translate(6 10) scale(-1 1) rotate(-90)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class RightArrowIcon extends React.Component {
  render() {
    return (
      <svg width="7" height="11" viewBox="0 0 7 11" fill="none">
        <path
          d="M0 0L4.5 5L9 0"
          transform="translate(1 10) rotate(-90)"
          stroke={this.props.color ? this.props.color : 'var(--color-spun-pearl-grey)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DownArrowIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path
          d="M1 1L5 5L9 1"
          stroke={this.props.color ? this.props.color : 'var(--color-spun-pearl-grey)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class EditIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class OvalIcon extends React.Component {
  render() {
    const { color } = this.props
    return (
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
          transform="translate(1 1)"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class CalendarIcon extends React.Component {
  render() {
    const { width, height } = this.props
    return (
      <svg width={width || '20'} height={height || '22'} viewBox="0 0 20 22" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2Z"
          transform="translate(1 3)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0V4"
          transform="translate(14 1)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0V4"
          transform="translate(6 1)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H18"
          transform="translate(1 9)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class PenIcon extends React.Component {
  render() {
    return (
      <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66667 0L12 3.33333L3.33333 12H0V8.66667L8.66667 0Z"
          transform="translate(1 1)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class PhotoIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 21 17" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 13.3333C19 14.2538 18.2267 15 17.2727 15H1.72727C0.773326 15 0 14.2538 0 13.3333V4.16667C0 3.24619 0.773326 2.5 1.72727 2.5H5.18182L6.90909 0H12.0909L13.8182 2.5H17.2727C18.2267 2.5 19 3.24619 19 4.16667V13.3333Z"
          transform="translate(1 1)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 5C3.88071 5 5 3.88071 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.88071 1.11929 5 2.5 5Z"
          transform="translate(8 7)"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class CogIcon extends React.Component {
  render() {
    return (
      <svg fill={this.props.color} width={this.props.width} height={this.props.height} viewBox="0 0 340.274 340.274">
        <g>
          <g>
            <g>
              <path
                d="M293.629,127.806l-5.795-13.739c19.846-44.856,18.53-46.189,14.676-50.08l-25.353-24.77l-2.516-2.12h-2.937
                c-1.549,0-6.173,0-44.712,17.48l-14.184-5.719c-18.332-45.444-20.212-45.444-25.58-45.444h-35.765
                c-5.362,0-7.446-0.006-24.448,45.606l-14.123,5.734C86.848,43.757,71.574,38.19,67.452,38.19l-3.381,0.105L36.801,65.032
                c-4.138,3.891-5.582,5.263,15.402,49.425l-5.774,13.691C0,146.097,0,147.838,0,153.33v35.068c0,5.501,0,7.44,46.585,24.127
                l5.773,13.667c-19.843,44.832-18.51,46.178-14.655,50.032l25.353,24.8l2.522,2.168h2.951c1.525,0,6.092,0,44.685-17.516
                l14.159,5.758c18.335,45.438,20.218,45.427,25.598,45.427h35.771c5.47,0,7.41,0,24.463-45.589l14.195-5.74
                c26.014,11,41.253,16.585,45.349,16.585l3.404-0.096l27.479-26.901c3.909-3.945,5.278-5.309-15.589-49.288l5.734-13.702
                c46.496-17.967,46.496-19.853,46.496-25.221v-35.029C340.268,146.361,340.268,144.434,293.629,127.806z M170.128,228.474
                c-32.798,0-59.504-26.187-59.504-58.364c0-32.153,26.707-58.315,59.504-58.315c32.78,0,59.43,26.168,59.43,58.315
                C229.552,202.287,202.902,228.474,170.128,228.474z"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export class EnterIcon extends React.Component {
  render() {
    return (
      <svg width={this.props.width} height={this.props.height} viewBox="0 0 16 16" fill="none">
        <rect width="14" height="14" fill="black" fillOpacity="0" transform="translate(1 1)" />
        <rect width="14" height="14" fill="black" fillOpacity="0" transform="translate(1 1)" />
        <path
          d="M5.375 6.25L1 10.625L5.375 15"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 1V7.125C15 9.058 13.433 10.625 11.5 10.625H1"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class UpIcon extends React.Component {
  render() {
    return (
      <svg width="12" height="16" viewBox="0 0 28 36" fill="none">
        <rect width="12" height="16" fill="black" fillOpacity="0" transform="translate(2 2) scale(2)" />
        <path
          d="M14 34V2"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 14L14 2L26 14"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DownIcon extends React.Component {
  render() {
    return (
      <svg width="12" height="16" viewBox="0 0 28 36" fill="none">
        <rect width="12" height="16" fill="black" fillOpacity="0" transform="translate(2 2) scale(2)" />
        <path
          d="M14 2V34"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26 22L14 34L2 22"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class IconChain extends React.Component {
  render() {
    return (
      <svg
        width={this.props.size ? this.props.size : '159'}
        height={this.props.size ? this.props.size : '156'}
        viewBox="0 0 159 156"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.649 104.019V104.143L85.4117 116.014L102.006 104.144L102.006 103.896C107.537 102.093 112.82 99.0479 117.233 94.6352L129.662 82.2057C138.975 72.8926 142.829 59.896 140.673 47.5463C140.236 45.0411 139.551 42.5626 138.615 40.1468C137.821 38.1006 136.848 36.0995 135.69 34.1653L135.752 34.1032C135.752 34.103 135.752 34.1034 135.752 34.1032C135.644 33.9246 135.533 33.746 135.422 33.5688C133.754 30.9114 131.817 28.4276 129.661 26.2718C123.447 20.057 115.305 16.0176 106.418 14.9609C94.2992 13.5315 82.3666 17.6336 73.7284 26.2718L61.299 38.7013C51.1066 48.8937 47.2535 63.8093 51.1687 77.1713C51.4171 78.4143 54.4001 86.6175 55.5187 87.1149C57.1968 89.9113 59.1237 92.4595 61.2987 94.6345C61.2984 94.6343 61.2989 94.6348 61.2987 94.6345C61.5781 94.914 61.8614 95.1885 62.147 95.4568C66.4347 99.4853 71.4055 102.271 76.649 104.019ZM114.063 41.8709C107.226 35.159 96.0401 35.0348 89.266 41.8088L76.8366 54.2383C72.7344 58.3404 71.1808 63.0013 71.4292 67.3518C71.678 71.7021 73.7284 75.8661 76.836 78.9736L77.0847 78.8491L88.3335 73.5663L101.696 79.0975L114.125 66.668C116.619 64.1745 118.256 61.0865 118.951 57.8237C119.009 57.5518 119.061 57.2787 119.106 57.0046C119.957 51.7973 118.43 46.2394 114.187 41.9961L114.063 41.8709Z"
          fill="var(--color-button-primary)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.649 104.019V104.143L85.4117 116.014L102.006 104.144L102.006 103.896C107.537 102.093 112.82 99.0479 117.233 94.6352L129.662 82.2057C138.975 72.8926 142.829 59.896 140.673 47.5463C140.236 45.0411 139.551 42.5626 138.615 40.1468C137.821 38.1006 136.848 36.0995 135.69 34.1653L135.752 34.1032C135.752 34.103 135.752 34.1034 135.752 34.1032C135.644 33.9246 135.533 33.746 135.422 33.5688C133.754 30.9114 131.817 28.4276 129.661 26.2718C123.447 20.057 115.305 16.0176 106.418 14.9609C94.2992 13.5315 82.3666 17.6336 73.7284 26.2718L61.299 38.7013C51.1066 48.8937 47.2535 63.8093 51.1687 77.1713C51.4171 78.4143 54.4001 86.6175 55.5187 87.1149C57.1968 89.9113 59.1237 92.4595 61.2987 94.6345C61.2984 94.6343 61.2989 94.6348 61.2987 94.6345C61.5781 94.914 61.8614 95.1885 62.147 95.4568C66.4347 99.4853 71.4055 102.271 76.649 104.019ZM114.063 41.8709C107.226 35.159 96.0401 35.0348 89.266 41.8088L76.8366 54.2383C72.7344 58.3404 71.1808 63.0013 71.4292 67.3518C71.678 71.7021 73.7284 75.8661 76.836 78.9736L77.0847 78.8491L88.3335 73.5663L101.696 79.0975L114.125 66.668C116.619 64.1745 118.256 61.0865 118.951 57.8237C119.009 57.5518 119.061 57.2787 119.106 57.0046C119.957 51.7973 118.43 46.2394 114.187 41.9961L114.063 41.8709Z"
          fill="white"
          fillOpacity="0.68"
        />
        <g filter="url(#filter0_d_1063_3334)">
          <path
            d="M147.436 20.9276L111.142 57.222C107.724 60.6401 102.13 60.6401 98.7122 57.222C95.2942 53.804 95.2942 48.2106 98.7122 44.7926L135.007 8.49785C138.337 5.16738 144.106 5.16738 147.436 8.49785C150.854 11.9159 150.854 17.5096 147.436 20.9276Z"
            fill="var(--color-button-primary)"
          />
        </g>
        <g filter="url(#filter1_d_1063_3334)">
          <path
            d="M94.4258 115.187C94.5268 110.876 89.6328 106.572 84.1367 105.858C83.5813 105.786 83.0271 105.702 82.4747 105.607C79.7516 105.136 76.9107 105.474 74.5614 106.771C74.3237 106.902 74.091 107.043 73.864 107.194C73.3429 107.541 72.8517 107.94 72.3979 108.394L64.5302 116.262C63.5049 117.287 62.4455 118.152 61.3646 118.869C59.685 119.983 57.9534 120.739 56.216 121.181C50.1254 122.732 43.9646 120.43 39.7337 116.2C33.4565 110.047 31.3439 99.73 39.6716 91.4026L52.101 78.9731C58.8754 72.1988 69.9378 72.3233 76.8358 78.9731L77.0224 79.1598C83.2372 85.2503 93.5541 87.2387 101.695 79.0971C101.795 78.9971 101.854 78.8661 101.863 78.73C101.865 78.6973 101.864 78.6642 101.861 78.6312C101.857 78.5918 101.848 78.5524 101.836 78.5138C101.036 76.0903 99.9049 73.672 98.5477 71.3655C98.5427 71.357 98.5402 71.3476 98.54 71.3382C98.5399 71.3235 98.5455 71.309 98.5564 71.298C98.5676 71.2868 98.5732 71.2718 98.5728 71.2568C98.5726 71.2471 98.5699 71.2374 98.5646 71.2287C97.8109 69.9936 96.9876 68.805 96.1097 67.668L96.0768 67.6257C94.9424 66.1604 93.7177 64.7811 92.4349 63.4985C88.0846 59.148 82.9263 55.8541 77.1466 53.9276C74.5984 52.995 71.9265 52.4361 69.2538 52.1249C63.2253 51.4417 57.2593 52.0631 51.7902 53.9278C46.1344 55.8541 40.9143 59.0859 36.5637 63.4364L24.134 75.8659C13.9419 86.0577 10.0891 100.973 13.9422 114.397C14.1455 115.17 15.4939 118.952 16.715 121.612C17.4609 123.237 18.5554 124.783 19.6051 126.265L19.6068 126.267C19.7641 126.489 19.9205 126.71 20.0745 126.929C21.3148 128.697 22.6682 130.332 24.1343 131.798C26.5284 134.192 29.1566 136.215 31.946 137.865C31.9701 137.88 31.9942 137.894 32.0185 137.908C47.1769 146.833 67.07 144.796 80.0675 131.799L92.497 119.369C93.4769 118.389 94.0529 117.335 94.2939 116.263C94.3742 115.906 94.4173 115.547 94.4258 115.187Z"
            fill="var(--color-button-primary)"
          />
        </g>
        <path
          d="M52.1007 116.263L14.9273 153.436C11.5093 156.854 5.91562 156.854 2.49785 153.436C-0.832617 150.106 -0.832617 144.337 2.49785 141.007L39.6715 103.833C43.0895 100.415 48.6829 100.415 52.1009 103.833C55.519 107.251 55.519 112.845 52.1007 116.263Z"
          fill="var(--color-button-primary)"
        />
        <path
          d="M52.1007 116.263L14.9273 153.436C11.5093 156.854 5.91562 156.854 2.49785 153.436C-0.832617 150.106 -0.832617 144.337 2.49785 141.007L39.6715 103.833C43.0895 100.415 48.6829 100.415 52.1009 103.833C55.519 107.251 55.519 112.845 52.1007 116.263Z"
          fill="white"
          fillOpacity="0.68"
        />
        <defs>
          <filter
            id="filter0_d_1063_3334"
            x="87.1487"
            y="0"
            width="71.8513"
            height="71.7852"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="4.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.0742893 0 0 0 0 0.269578 0 0 0 0 0.72821 0 0 0 0.206267 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1063_3334" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1063_3334" result="shape" />
          </filter>
          <filter
            id="filter1_d_1063_3334"
            x="3.4751"
            y="45.8555"
            width="107.389"
            height="109.503"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="4.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.0742893 0 0 0 0 0.269578 0 0 0 0 0.72821 0 0 0 0.206267 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1063_3334" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1063_3334" result="shape" />
          </filter>
        </defs>
      </svg>
    )
  }
}

export class Icon404 extends React.Component {
  render() {
    return (
      <svg width="354" height="153" viewBox="0 0 354 153" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M58.3865 117.374H9.04498C3.90575 117.374 0 113.885 0 107.934C0 106.293 27.1349 6.97684 27.1349 6.97684C29.6019 1.84669 34.125 0 38.4422 0C43.1707 0 55.029 3.18409 55.029 9.3411C55.029 10.3673 55.0795 12.5176 54.4621 13.748L34.3318 92.5442H58.3865V70.9988C58.3865 65.0489 65.1706 62.5859 71.7493 62.5859C78.5348 62.5859 85.1128 65.0482 85.1128 70.9988V92.5442H94.7752C100.327 92.5442 103.205 98.7006 103.205 105.061C103.205 111.217 99.0917 117.374 94.7752 117.374H85.1128V141.587C85.1128 147.128 78.5341 150 71.7493 150C65.1706 150 58.3865 147.127 58.3865 141.587V117.374Z"
          fill="var(--color-pressed-overlay-primary)"
        />
        <path
          d="M58.3865 117.374H9.04498C3.90575 117.374 0 113.885 0 107.934C0 106.293 27.1349 6.97684 27.1349 6.97684C29.6019 1.84669 34.125 0 38.4422 0C43.1707 0 55.029 3.18409 55.029 9.3411C55.029 10.3673 55.0795 12.5176 54.4621 13.748L34.3318 92.5442H58.3865V70.9988C58.3865 65.0489 65.1706 62.5859 71.7493 62.5859C78.5348 62.5859 85.1128 65.0482 85.1128 70.9988V92.5442H94.7752C100.327 92.5442 103.205 98.7006 103.205 105.061C103.205 111.217 99.0917 117.374 94.7752 117.374H85.1128V141.587C85.1128 147.128 78.5341 150 71.7493 150C65.1706 150 58.3865 147.127 58.3865 141.587V117.374Z"
          fill="white"
          fillOpacity="0"
        />
        <path
          d="M270.004 36.0587C274.461 19.6718 277.929 6.97684 277.929 6.97684C280.396 1.84669 284.919 0 289.237 0C293.965 0 305.823 3.18409 305.823 9.3411C305.823 10.3673 305.874 12.5176 305.257 13.748L285.127 92.5442H309.182V70.9988C309.182 65.0489 315.966 62.5859 322.544 62.5859C329.33 62.5859 335.908 65.0482 335.908 70.9988V92.5442H345.57C351.122 92.5442 354 98.7006 354 105.061C354 111.217 349.887 117.374 345.57 117.374H335.908V141.587C335.908 147.128 329.329 150 322.544 150C315.966 150 309.182 147.127 309.182 141.587V117.374H259.839C254.7 117.374 250.794 113.885 250.794 107.934C250.794 107.112 257.598 81.8009 264.392 56.7312L270.004 36.0587Z"
          fill="var(--color-pressed-overlay-primary)"
        />
        <path
          d="M270.004 36.0587C274.461 19.6718 277.929 6.97684 277.929 6.97684C280.396 1.84669 284.919 0 289.237 0C293.965 0 305.823 3.18409 305.823 9.3411C305.823 10.3673 305.874 12.5176 305.257 13.748L285.127 92.5442H309.182V70.9988C309.182 65.0489 315.966 62.5859 322.544 62.5859C329.33 62.5859 335.908 65.0482 335.908 70.9988V92.5442H345.57C351.122 92.5442 354 98.7006 354 105.061C354 111.217 349.887 117.374 345.57 117.374H335.908V141.587C335.908 147.128 329.329 150 322.544 150C315.966 150 309.182 147.127 309.182 141.587V117.374H259.839C254.7 117.374 250.794 113.885 250.794 107.934C250.794 107.112 257.598 81.8009 264.392 56.7312L270.004 36.0587Z"
          fill="white"
          fillOpacity="0"
        />
        <g filter="url(#filter0_d_1063_3373)">
          <path
            d="M177.006 140.942C210.793 140.942 238.182 113.604 238.182 79.8814C238.182 46.1588 210.793 18.8213 177.006 18.8213C143.219 18.8213 115.83 46.1588 115.83 79.8814C115.83 113.604 143.219 140.942 177.006 140.942Z"
            fill="var(--color-general-ui)"
          />
        </g>
        <path
          d="M184.667 79.8834L205.946 58.6445C208.062 56.5328 208.062 53.1078 205.946 50.9968C203.829 48.8852 200.399 48.8852 198.283 50.9968L177.004 72.2358L155.724 50.9968C153.607 48.8852 150.177 48.8852 148.061 50.9968C145.946 53.1085 145.946 56.5335 148.061 58.6445L169.341 79.8834L148.061 101.122C145.946 103.234 145.946 106.659 148.061 108.77C149.12 109.826 150.507 110.355 151.893 110.355C153.279 110.355 154.666 109.827 155.725 108.77L177.004 87.5311L198.284 108.77C199.342 109.826 200.729 110.355 202.116 110.355C203.502 110.355 204.889 109.827 205.947 108.77C208.063 106.658 208.063 103.233 205.947 101.122L184.667 79.8834Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_1063_3373"
            x="106.83"
            y="12.8213"
            width="140.353"
            height="140.12"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="4.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.0742893 0 0 0 0 0.269578 0 0 0 0 0.72821 0 0 0 0.206267 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1063_3373" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1063_3373" result="shape" />
          </filter>
        </defs>
      </svg>
    )
  }
}

export class ThreeIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="6" viewBox="0 0 22 6" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5C12.1046 5 13 4.10457 13 3C13 1.89543 12.1046 1 11 1C9.89543 1 9 1.89543 9 3C9 4.10457 9.89543 5 11 5Z"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 5C20.1046 5 21 4.10457 21 3C21 1.89543 20.1046 1 19 1C17.8954 1 17 1.89543 17 3C17 4.10457 17.8954 5 19 5Z"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3C1 4.10457 1.89543 5 3 5Z"
          stroke="var(--color-spun-pearl-grey)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class BackIcon extends React.Component {
  render() {
    return (
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
          d="M7 13L1 7L7 1"
          stroke="var(--color-text-primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class EditMenuIcon extends React.Component {
  render() {
    return (
      <svg width="6" height="9" viewBox="0 0 6 9" fill="none">
        <path
          d="M1 8L5 4.5L1 1"
          stroke="var(--color-button-primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class LinkIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          d="M8.98865 12.0067C9.86254 13.1762 11.2008 13.908 12.656 14.0123C14.1112 14.1167 15.54 13.5832 16.5714 12.5503L19.5885 9.53023C21.4941 7.55522 21.4668 4.41583 19.5272 2.47426C17.5876 0.532693 14.4514 0.505413 12.4783 2.41295L10.7486 4.13438"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0114 9.99331C12.1375 8.82385 10.7992 8.09198 9.344 7.98765C7.88877 7.88333 6.46001 8.41683 5.42856 9.4497L2.41153 12.4698C0.50591 14.4448 0.533163 17.5842 2.47278 19.5257C4.4124 21.4673 7.54863 21.4946 9.52166 19.5871L11.2414 17.8656"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class WelcomeIcon extends React.Component {
  render() {
    return (
      <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
        <path d="M15 5H1" stroke="#8EB0F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19 1H1" stroke="#8EB0F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19 9H1" stroke="#8EB0F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 13H1" stroke="#8EB0F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
}

export class DelayIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M11 7V11" stroke="#8EB0F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
}

export class CustomizationIcon extends React.Component {
  render() {
    return (
      <svg width="20" height="22" viewBox="0 0 20 22" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1L16 5L5 16H1V12L12 1V1Z"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M1 21H19" stroke="#8EB0F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
}

export class HelloIcon extends React.Component {
  render() {
    return (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path opacity="0.5" d="M0 14.63H14V0.63H0V14.63Z" fill="url(#pattern0)" />
        <defs>
          <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use href="#image0" transform="scale(0.015625)" />
          </pattern>
          <image
            id="image0"
            width="64"
            height="64"
            href="data:image/png;base64,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"
          />
        </defs>
      </svg>
    )
  }
}

export const CopyIcon = props => {
  const { width, height, color } = props
  return (
    <svg width={width || 20} height={height || 20} viewBox="0 0 20 20" fill="none">
      <path
        d="M17.1998 7.30002H9.0998C8.10569 7.30002 7.2998 8.10591 7.2998 9.10002V17.2C7.2998 18.1941 8.10569 19 9.0998 19H17.1998C18.1939 19 18.9998 18.1941 18.9998 17.2V9.10002C18.9998 8.10591 18.1939 7.30002 17.1998 7.30002Z"
        stroke={color || 'var(--color-oxford-blue)}'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7 12.7H2.8C2.32261 12.7 1.86477 12.5104 1.52721 12.1728C1.18964 11.8352 1 11.3774 1 10.9V2.8C1 2.32261 1.18964 1.86477 1.52721 1.52721C1.86477 1.18964 2.32261 1 2.8 1H10.9C11.3774 1 11.8352 1.18964 12.1728 1.52721C12.5104 1.86477 12.7 2.32261 12.7 2.8V3.7"
        stroke={color || 'var(--color-oxford-blue)}'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const EmailIcon = ({ color }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_5340_68288"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="12"
      height="12">
      <rect width="12" height="12" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5340_68288)">
      <path
        d="M2 10C1.725 10 1.48958 9.90208 1.29375 9.70625C1.09792 9.51042 1 9.275 1 9V3C1 2.725 1.09792 2.48958 1.29375 2.29375C1.48958 2.09792 1.725 2 2 2H10C10.275 2 10.5104 2.09792 10.7063 2.29375C10.9021 2.48958 11 2.725 11 3V9C11 9.275 10.9021 9.51042 10.7063 9.70625C10.5104 9.90208 10.275 10 10 10H2ZM6 6.5L2 4V9H10V4L6 6.5ZM6 5.5L10 3H2L6 5.5ZM2 4V3V9V4Z"
        fill={color || '#489B00'}
      />
    </g>
  </svg>
)

export const WarningIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.86523 20.5L11.9997 3L22.1342 20.5H1.86523ZM4.44973 19H19.5497L11.9997 6L4.44973 19ZM11.9997 17.8077C12.2286 17.8077 12.4204 17.7303 12.5752 17.5755C12.7301 17.4207 12.8075 17.2288 12.8075 17C12.8075 16.7712 12.7301 16.5793 12.5752 16.4245C12.4204 16.2697 12.2286 16.1923 11.9997 16.1923C11.7709 16.1923 11.5791 16.2697 11.4242 16.4245C11.2694 16.5793 11.192 16.7712 11.192 17C11.192 17.2288 11.2694 17.4207 11.4242 17.5755C11.5791 17.7303 11.7709 17.8077 11.9997 17.8077ZM11.2497 15.1923H12.7497V10.1923H11.2497V15.1923Z"
      fill="#FF2929"
    />
  </svg>
)

export const TrashDarkIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 6H5H21"
      stroke="var(--color-oxford-blue)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
      stroke="var(--color-oxford-blue)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11V17"
      stroke="var(--color-oxford-blue)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 11V17"
      stroke="var(--color-oxford-blue)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChevronLeftIcon = ({ width, height, color }) => (
  <svg width={width || 7} height={height || 11} viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 10L1 5.5L6 1"
      stroke={color || 'var(--color-spun-pearl-grey)'}
      strokeWidth={width ? '1' : '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChevronRightIcon = () => (
  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 10L6 5.5L1 1"
      stroke="var(--color-spun-pearl-grey)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LongArrowLeftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33337 9.99996C3.33337 9.53972 3.70647 9.16663 4.16671 9.16663H15.8334C16.2936 9.16663 16.6667 9.53972 16.6667 9.99996C16.6667 10.4602 16.2936 10.8333 15.8334 10.8333H4.16671C3.70647 10.8333 3.33337 10.4602 3.33337 9.99996Z"
      fill="var(--color-button-primary)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5893 3.57745C10.9147 3.90289 10.9147 4.43053 10.5893 4.75596L5.34522 10L10.5893 15.2441C10.9147 15.5696 10.9147 16.0972 10.5893 16.4226C10.2639 16.7481 9.73622 16.7481 9.41078 16.4226L3.57745 10.5893C3.25201 10.2639 3.25201 9.73622 3.57745 9.41078L9.41078 3.57745C9.73622 3.25201 10.2639 3.25201 10.5893 3.57745Z"
      fill="var(--color-button-primary)"
    />
  </svg>
)

export const LongArrowRightIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6666 10C16.6666 10.4603 16.2935 10.8334 15.8333 10.8334L4.16663 10.8334C3.70639 10.8334 3.33329 10.4603 3.33329 10C3.33329 9.5398 3.70639 9.16671 4.16663 9.16671L15.8333 9.16671C16.2935 9.16671 16.6666 9.5398 16.6666 10Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.41071 16.4225C9.08527 16.0971 9.08527 15.5695 9.41071 15.244L14.6548 9.99996L9.41071 4.75588C9.08527 4.43045 9.08527 3.90281 9.41071 3.57737C9.73614 3.25194 10.2638 3.25194 10.5892 3.57737L16.4225 9.41071C16.748 9.73614 16.748 10.2638 16.4225 10.5892L10.5892 16.4225C10.2638 16.748 9.73614 16.748 9.41071 16.4225Z"
      fill="white"
    />
  </svg>
)

export const MoreHorizontalIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      stroke="var(--color-oxford-blue)"
      stroke-opacity="0.7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
      stroke="var(--color-oxford-blue)"
      stroke-opacity="0.7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
      stroke="var(--color-oxford-blue)"
      stroke-opacity="0.7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DeleteIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.33335 8.33337C8.79359 8.33337 9.16669 8.70647 9.16669 9.16671V14.1667C9.16669 14.6269 8.79359 15 8.33335 15C7.87312 15 7.50002 14.6269 7.50002 14.1667V9.16671C7.50002 8.70647 7.87312 8.33337 8.33335 8.33337Z"
      fill="#FF6666"
    />
    <path
      d="M12.5 14.1667V9.16671C12.5 8.70647 12.1269 8.33337 11.6667 8.33337C11.2064 8.33337 10.8334 8.70647 10.8334 9.16671V14.1667C10.8334 14.6269 11.2064 15 11.6667 15C12.1269 15 12.5 14.6269 12.5 14.1667Z"
      fill="#FF6666"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83335 4.16671V3.33337C5.83335 2.67033 6.09675 2.03445 6.56559 1.56561C7.03443 1.09677 7.67031 0.833374 8.33335 0.833374H11.6667C12.3297 0.833374 12.9656 1.09677 13.4345 1.56561C13.9033 2.03445 14.1667 2.67033 14.1667 3.33337V4.16671H17.5C17.9603 4.16671 18.3334 4.5398 18.3334 5.00004C18.3334 5.46028 17.9603 5.83337 17.5 5.83337H16.6667V16.6667C16.6667 17.3297 16.4033 17.9656 15.9345 18.4345C15.4656 18.9033 14.8297 19.1667 14.1667 19.1667H5.83335C5.17031 19.1667 4.53443 18.9033 4.06559 18.4345C3.59675 17.9656 3.33335 17.3297 3.33335 16.6667V5.83337H2.50002C2.03978 5.83337 1.66669 5.46028 1.66669 5.00004C1.66669 4.5398 2.03978 4.16671 2.50002 4.16671H5.83335ZM7.7441 2.74412C7.90038 2.58784 8.11234 2.50004 8.33335 2.50004H11.6667C11.8877 2.50004 12.0997 2.58784 12.2559 2.74412C12.4122 2.9004 12.5 3.11236 12.5 3.33337V4.16671H7.50002V3.33337C7.50002 3.11236 7.58782 2.9004 7.7441 2.74412ZM5.00002 5.83337V16.6667C5.00002 16.8877 5.08782 17.0997 5.2441 17.256C5.40038 17.4122 5.61234 17.5 5.83335 17.5H14.1667C14.3877 17.5 14.5997 17.4122 14.7559 17.256C14.9122 17.0997 15 16.8877 15 16.6667V5.83337H5.00002Z"
      fill="#FF6666"
    />
  </svg>
)

export const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 4H3.33333H14"
      stroke="var(--color-pale-sky)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 4.00016V13.3335C12.6667 13.6871 12.5262 14.0263 12.2762 14.2763C12.0261 14.5264 11.687 14.6668 11.3334 14.6668H4.66671C4.31309 14.6668 3.97395 14.5264 3.7239 14.2763C3.47385 14.0263 3.33337 13.6871 3.33337 13.3335V4.00016M5.33337 4.00016V2.66683C5.33337 2.31321 5.47385 1.97407 5.7239 1.72402C5.97395 1.47397 6.31309 1.3335 6.66671 1.3335H9.33337C9.687 1.3335 10.0261 1.47397 10.2762 1.72402C10.5262 1.97407 10.6667 2.31321 10.6667 2.66683V4.00016"
      stroke="var(--color-pale-sky)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ReactionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.77782 6.51868H5.78523M10.2223 6.51868H10.2297M6.14819 10.2224C6.38958 10.4688 6.67771 10.6645 6.99569 10.7981C7.31367 10.9317 7.65512 11.0005 8.00004 11.0005C8.34496 11.0005 8.68641 10.9317 9.00439 10.7981C9.32238 10.6645 9.6105 10.4688 9.85189 10.2224M1.33337 8.00016C1.33337 8.87564 1.50581 9.74255 1.84084 10.5514C2.17588 11.3602 2.66694 12.0952 3.286 12.7142C3.90505 13.3333 4.63998 13.8243 5.44882 14.1594C6.25766 14.4944 7.12456 14.6668 8.00004 14.6668C8.87552 14.6668 9.74243 14.4944 10.5513 14.1594C11.3601 13.8243 12.095 13.3333 12.7141 12.7142C13.3331 12.0952 13.8242 11.3602 14.1592 10.5514C14.4943 9.74255 14.6667 8.87564 14.6667 8.00016C14.6667 7.12468 14.4943 6.25778 14.1592 5.44894C13.8242 4.6401 13.3331 3.90517 12.7141 3.28612C12.095 2.66706 11.3601 2.176 10.5513 1.84097C9.74243 1.50593 8.87552 1.3335 8.00004 1.3335C7.12456 1.3335 6.25766 1.50593 5.44882 1.84097C4.63998 2.176 3.90505 2.66706 3.286 3.28612C2.66694 3.90517 2.17588 4.6401 1.84084 5.44894C1.50581 6.25778 1.33337 7.12468 1.33337 8.00016Z"
      stroke="var(--color-pale-sky)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 4L5.99996 11.3333L2.66663 8"
      stroke="var(--color-malachite-green)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.21967 4.26947C6.51256 3.97658 6.98744 3.97658 7.28033 4.26947L11.7803 8.76947C11.921 8.91013 12 9.10089 12 9.2998C12 9.49872 11.921 9.68948 11.7803 9.83013L7.28033 14.3301C6.98744 14.623 6.51256 14.623 6.21967 14.3301C5.92678 14.0372 5.92678 13.5624 6.21967 13.2695L10.1893 9.2998L6.21967 5.33013C5.92678 5.03724 5.92678 4.56237 6.21967 4.26947Z"
      fill="#6D7686"
    />
  </svg>
)

export class LogoIcon extends React.Component {
  render() {
    return (
      <svg width="36.02px" height="36.02px" viewBox="0 0 152 152" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M107.721 44.0499C115.62 45.3727 122.537 48.3207 128.395 52.4026C135.198 57.2026 140.603 63.59 144.458 70.8467C148.389 78.2546 150.619 86.5318 150.997 94.8845C151.413 103.124 150.052 111.477 146.802 119.187C142.795 128.711 136.068 137.14 126.354 142.998C117.813 148.214 107.003 151.351 93.7747 151.426V151.464C83.57 151.464 74.9527 151.464 67.6582 151.464V151.54H0.231445V123.798L0.269241 116.692C0.269241 100.554 0.307036 84.3774 0.307036 57.9585C0.382626 44.768 3.55743 33.9585 8.73538 25.379C14.5936 15.7034 23.0598 8.93807 32.5842 4.93177C40.2944 1.71917 48.6472 0.320748 56.8866 0.736496C65.2393 1.15224 73.5165 3.38217 80.9244 7.31287C88.1433 11.1302 94.5307 16.5349 99.3307 23.3759C103.45 29.2341 106.398 36.1507 107.721 44.0499ZM67.6582 123.798L93.5858 123.76C100.842 123.722 106.625 122.173 111.123 119.64C116.074 116.881 119.4 112.875 121.29 108.377C122.915 104.56 123.557 100.327 123.331 96.094C123.104 91.7853 121.97 87.5144 120.005 83.7727C112.257 69.1837 98.3858 70.6955 83.9858 72.2452L78.9968 72.8121L79.5637 67.0294C81.0377 52.8562 82.4362 39.4389 67.9606 31.7664C64.2188 29.8011 59.9858 28.6294 55.6771 28.4026C51.444 28.2137 47.211 28.8562 43.3937 30.4436C38.8582 32.3333 34.8897 35.6971 32.0929 40.6105C29.5606 45.1082 28.011 50.9286 27.9732 58.1853L27.9354 92.6924H27.8976V123.798H67.6582Z"
          fill="white"
        />
      </svg>
    )
  }
}

export const AddSectionIcon = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_4529_15805"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="19"
      height="18">
      <rect x="0.5" width="18" height="18" fill="var(--color-issabeline-grey)" />
    </mask>
    <g mask="url(#mask0_4529_15805)">
      <path
        d="M4.25 7.5H14.75V3H4.25V7.5ZM2.75 15V1.5H16.25V15H13.25V13.5H14.75V9H4.25V13.5H5.75V15H2.75ZM8.75 16.5V15H7.25V13.5H8.75V12H10.25V13.5H11.75V15H10.25V16.5H8.75Z"
        fill="var(--color-button-primary)"
      />
    </g>
  </svg>
)

export const ErrorSignIcon = () => (
  <svg
    width="24"
    style={{ color: 'var(--color-text-error)', margin: '0 6px' }}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
      fill="var(--color-text-error)"
    />
  </svg>
)

export const UserIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3668_57651"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30">
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3668_57651)">
        <path
          d="M0 22.5V20.5312C0 19.6354 0.458333 18.9062 1.375 18.3438C2.29167 17.7812 3.5 17.5 5 17.5C5.27083 17.5 5.53125 17.5052 5.78125 17.5156C6.03125 17.526 6.27083 17.5521 6.5 17.5938C6.20833 18.0312 5.98958 18.4896 5.84375 18.9688C5.69792 19.4479 5.625 19.9479 5.625 20.4688V22.5H0ZM7.5 22.5V20.4688C7.5 19.8021 7.68229 19.1927 8.04688 18.6406C8.41146 18.0885 8.92708 17.6042 9.59375 17.1875C10.2604 16.7708 11.0573 16.4583 11.9844 16.25C12.9115 16.0417 13.9167 15.9375 15 15.9375C16.1042 15.9375 17.1198 16.0417 18.0469 16.25C18.974 16.4583 19.7708 16.7708 20.4375 17.1875C21.1042 17.6042 21.6146 18.0885 21.9688 18.6406C22.3229 19.1927 22.5 19.8021 22.5 20.4688V22.5H7.5ZM24.375 22.5V20.4688C24.375 19.9271 24.3073 19.4167 24.1719 18.9375C24.0365 18.4583 23.8333 18.0104 23.5625 17.5938C23.7917 17.5521 24.026 17.526 24.2656 17.5156C24.5052 17.5052 24.75 17.5 25 17.5C26.5 17.5 27.7083 17.776 28.625 18.3281C29.5417 18.8802 30 19.6146 30 20.5312V22.5H24.375ZM10.1562 20H19.875C19.6667 19.5833 19.0885 19.2188 18.1406 18.9062C17.1927 18.5938 16.1458 18.4375 15 18.4375C13.8542 18.4375 12.8073 18.5938 11.8594 18.9062C10.9115 19.2188 10.3438 19.5833 10.1562 20ZM5 16.25C4.3125 16.25 3.72396 16.0052 3.23438 15.5156C2.74479 15.026 2.5 14.4375 2.5 13.75C2.5 13.0417 2.74479 12.4479 3.23438 11.9688C3.72396 11.4896 4.3125 11.25 5 11.25C5.70833 11.25 6.30208 11.4896 6.78125 11.9688C7.26042 12.4479 7.5 13.0417 7.5 13.75C7.5 14.4375 7.26042 15.026 6.78125 15.5156C6.30208 16.0052 5.70833 16.25 5 16.25ZM25 16.25C24.3125 16.25 23.724 16.0052 23.2344 15.5156C22.7448 15.026 22.5 14.4375 22.5 13.75C22.5 13.0417 22.7448 12.4479 23.2344 11.9688C23.724 11.4896 24.3125 11.25 25 11.25C25.7083 11.25 26.3021 11.4896 26.7813 11.9688C27.2604 12.4479 27.5 13.0417 27.5 13.75C27.5 14.4375 27.2604 15.026 26.7813 15.5156C26.3021 16.0052 25.7083 16.25 25 16.25ZM15 15C13.9583 15 13.0729 14.6354 12.3438 13.9062C11.6146 13.1771 11.25 12.2917 11.25 11.25C11.25 10.1875 11.6146 9.29688 12.3438 8.57812C13.0729 7.85938 13.9583 7.5 15 7.5C16.0625 7.5 16.9531 7.85938 17.6719 8.57812C18.3906 9.29688 18.75 10.1875 18.75 11.25C18.75 12.2917 18.3906 13.1771 17.6719 13.9062C16.9531 14.6354 16.0625 15 15 15ZM15 12.5C15.3542 12.5 15.651 12.3802 15.8906 12.1406C16.1302 11.901 16.25 11.6042 16.25 11.25C16.25 10.8958 16.1302 10.599 15.8906 10.3594C15.651 10.1198 15.3542 10 15 10C14.6458 10 14.349 10.1198 14.1094 10.3594C13.8698 10.599 13.75 10.8958 13.75 11.25C13.75 11.6042 13.8698 11.901 14.1094 12.1406C14.349 12.3802 14.6458 12.5 15 12.5Z"
          fill="#616581"
        />
      </g>
    </svg>
  )
}

export const RightIcon = ({ onClick, size }) => {
  return (
    <svg
      style={{ cursor: 'pointer' }}
      onClick={onClick}
      width={size ? size : 24}
      height={size ? size : 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3668_57962"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={size ? size : 24}
        height={size ? size : 24}>
        <rect width={size ? size : 24} height={size ? size : 24} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3668_57962)">
        <path d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z" fill="#616581" />
      </g>
    </svg>
  )
}

export const ServiceUserIcon = () => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3668_57475"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="29">
        <rect y="0.5" width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3668_57475)">
        <path
          d="M8.74935 4C9.76046 4 10.723 4.21389 11.6368 4.64167C12.5507 5.06944 13.3382 5.67222 13.9993 6.45C14.6605 5.67222 15.448 5.06944 16.3618 4.64167C17.2757 4.21389 18.2382 4 19.2493 4C21.0771 4 22.6035 4.6125 23.8285 5.8375C25.0535 7.0625 25.666 8.58889 25.666 10.4167C25.666 10.5139 25.6612 10.6111 25.6514 10.7083C25.6417 10.8056 25.6368 10.9028 25.6368 11H23.3035C23.323 10.9028 23.3327 10.8056 23.3327 10.7083V10.4167C23.3327 9.25 22.9438 8.27778 22.166 7.5C21.3882 6.72222 20.416 6.33333 19.2493 6.33333C18.3355 6.33333 17.4896 6.59097 16.7118 7.10625C15.9341 7.62153 15.3993 8.27778 15.1077 9.075H12.891C12.5993 8.27778 12.0646 7.62153 11.2868 7.10625C10.5091 6.59097 9.66324 6.33333 8.74935 6.33333C7.58268 6.33333 6.61046 6.72222 5.83268 7.5C5.0549 8.27778 4.66602 9.25 4.66602 10.4167V10.7083C4.66602 10.8056 4.67574 10.9028 4.69518 11H2.36185C2.36185 10.9028 2.35699 10.8056 2.34727 10.7083C2.33754 10.6111 2.33268 10.5139 2.33268 10.4167C2.33268 8.58889 2.94518 7.0625 4.17018 5.8375C5.39518 4.6125 6.92157 4 8.74935 4ZM6.18268 18H9.44935C10.0716 18.6028 10.7521 19.2542 11.491 19.9542C12.2299 20.6542 13.066 21.4222 13.9993 22.2583C14.9327 21.4222 15.7688 20.6542 16.5077 19.9542C17.2466 19.2542 17.9271 18.6028 18.5493 18H21.8452C21.1063 18.8167 20.2313 19.7014 19.2202 20.6542C18.2091 21.6069 17.0327 22.6861 15.691 23.8917L13.9993 25.4083L12.3077 23.8917C10.966 22.6861 9.79449 21.6069 8.7931 20.6542C7.79171 19.7014 6.92157 18.8167 6.18268 18ZM12.891 19.1667C13.1438 19.1667 13.3625 19.0937 13.5473 18.9479C13.732 18.8021 13.8632 18.6125 13.941 18.3792L15.516 13.625L16.5368 15.1417C16.6341 15.2972 16.7702 15.4236 16.9452 15.5208C17.1202 15.6181 17.3049 15.6667 17.4993 15.6667H26.8327V13.3333H18.1702L16.1577 10.3583C16.041 10.1833 15.8903 10.0521 15.7056 9.96458C15.5209 9.87708 15.3216 9.83333 15.1077 9.83333C14.8549 9.83333 14.6362 9.90625 14.4514 10.0521C14.2667 10.1979 14.1355 10.3875 14.0577 10.6208L12.4827 15.3458L11.491 13.8583C11.3938 13.7028 11.2577 13.5764 11.0827 13.4792C10.9077 13.3819 10.723 13.3333 10.5285 13.3333H1.16602V15.6667H9.82852L11.841 18.6417C11.9577 18.8167 12.1084 18.9479 12.2931 19.0354C12.4778 19.1229 12.6771 19.1667 12.891 19.1667Z"
          fill="#616581"
        />
      </g>
    </svg>
  )
}

export const AdminIcon = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3668_57464"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28">
        <rect width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3668_57464)">
        <path
          d="M11.6673 14.0013C10.384 14.0013 9.28537 13.5444 8.37148 12.6305C7.4576 11.7166 7.00065 10.618 7.00065 9.33464C7.00065 8.0513 7.4576 6.95269 8.37148 6.0388C9.28537 5.12491 10.384 4.66797 11.6673 4.66797C12.9507 4.66797 14.0493 5.12491 14.9632 6.0388C15.877 6.95269 16.334 8.0513 16.334 9.33464C16.334 10.618 15.877 11.7166 14.9632 12.6305C14.0493 13.5444 12.9507 14.0013 11.6673 14.0013ZM2.33398 23.3346V20.068C2.33398 19.4263 2.49926 18.8235 2.82982 18.2596C3.16037 17.6957 3.61732 17.268 4.20065 16.9763C5.19232 16.4707 6.31037 16.043 7.55482 15.693C8.79926 15.343 10.1701 15.168 11.6673 15.168H12.0757C12.1923 15.168 12.309 15.1874 12.4257 15.2263C12.2701 15.5763 12.1388 15.9409 12.0319 16.3201C11.925 16.6992 11.8423 17.093 11.784 17.5013H11.6673C10.2868 17.5013 9.04718 17.6763 7.94857 18.0263C6.84996 18.3763 5.95065 18.7263 5.25065 19.0763C5.07565 19.1735 4.93468 19.3096 4.82773 19.4846C4.72079 19.6596 4.66732 19.8541 4.66732 20.068V21.0013H12.0173C12.134 21.4096 12.2895 21.8131 12.484 22.2117C12.6784 22.6103 12.8923 22.9846 13.1257 23.3346H2.33398ZM18.6673 24.5013L18.3173 22.7513C18.084 22.6541 17.8652 22.552 17.6611 22.4451C17.4569 22.3381 17.2479 22.2069 17.034 22.0513L15.3423 22.5763L14.1757 20.593L15.5173 19.4263C15.4784 19.1541 15.459 18.9013 15.459 18.668C15.459 18.4346 15.4784 18.1819 15.5173 17.9096L14.1757 16.743L15.3423 14.7596L17.034 15.2846C17.2479 15.1291 17.4569 14.9978 17.6611 14.8909C17.8652 14.7839 18.084 14.6819 18.3173 14.5846L18.6673 12.8346H21.0007L21.3507 14.5846C21.584 14.6819 21.8027 14.7888 22.0069 14.9055C22.2111 15.0221 22.4201 15.168 22.634 15.343L24.3257 14.7596L25.4923 16.8013L24.1507 17.968C24.1895 18.2013 24.209 18.4444 24.209 18.6971C24.209 18.9499 24.1895 19.193 24.1507 19.4263L25.4923 20.593L24.3257 22.5763L22.634 22.0513C22.4201 22.2069 22.2111 22.3381 22.0069 22.4451C21.8027 22.552 21.584 22.6541 21.3507 22.7513L21.0007 24.5013H18.6673ZM19.834 21.0013C20.4757 21.0013 21.025 20.7728 21.4819 20.3159C21.9388 19.8589 22.1673 19.3096 22.1673 18.668C22.1673 18.0263 21.9388 17.477 21.4819 17.0201C21.025 16.5631 20.4757 16.3346 19.834 16.3346C19.1923 16.3346 18.643 16.5631 18.1861 17.0201C17.7291 17.477 17.5007 18.0263 17.5007 18.668C17.5007 19.3096 17.7291 19.8589 18.1861 20.3159C18.643 20.7728 19.1923 21.0013 19.834 21.0013ZM11.6673 11.668C12.309 11.668 12.8583 11.4395 13.3152 10.9826C13.7722 10.5256 14.0007 9.9763 14.0007 9.33464C14.0007 8.69297 13.7722 8.14366 13.3152 7.68672C12.8583 7.22977 12.309 7.0013 11.6673 7.0013C11.0257 7.0013 10.4763 7.22977 10.0194 7.68672C9.56246 8.14366 9.33398 8.69297 9.33398 9.33464C9.33398 9.9763 9.56246 10.5256 10.0194 10.9826C10.4763 11.4395 11.0257 11.668 11.6673 11.668Z"
          fill="#616581"
        />
      </g>
    </svg>
  )
}

export const CarerIcon = () => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3668_57453"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="29">
        <rect y="0.5" width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3668_57453)">
        <path
          d="M14.0007 10.9987C12.8729 10.9987 11.9104 10.6001 11.1132 9.80287C10.3159 9.00564 9.91732 8.04314 9.91732 6.91536C9.91732 5.78759 10.3159 4.82509 11.1132 4.02786C11.9104 3.23064 12.8729 2.83203 14.0007 2.83203C15.1284 2.83203 16.0909 3.23064 16.8882 4.02786C17.6854 4.82509 18.084 5.78759 18.084 6.91536C18.084 8.04314 17.6854 9.00564 16.8882 9.80287C16.0909 10.6001 15.1284 10.9987 14.0007 10.9987ZM14.0007 8.66537C14.4868 8.66537 14.9 8.49523 15.2402 8.15495C15.5805 7.81467 15.7507 7.40148 15.7507 6.91536C15.7507 6.42925 15.5805 6.01606 15.2402 5.67578C14.9 5.3355 14.4868 5.16536 14.0007 5.16536C13.5145 5.16536 13.1013 5.3355 12.7611 5.67578C12.4208 6.01606 12.2507 6.42925 12.2507 6.91536C12.2507 7.40148 12.4208 7.81467 12.7611 8.15495C13.1013 8.49523 13.5145 8.66537 14.0007 8.66537ZM14.0007 26.1654L7.00065 19.1654C6.61176 18.7765 6.3201 18.339 6.12565 17.8529C5.93121 17.3668 5.83398 16.832 5.83398 16.2487C5.83398 15.1015 6.22773 14.1341 7.01523 13.3466C7.80273 12.5591 8.7701 12.1654 9.91732 12.1654C10.4812 12.1654 11.0013 12.2723 11.4777 12.4862C11.9541 12.7001 12.3868 13.0015 12.7757 13.3904L14.0007 14.6154L15.2257 13.3904C15.6145 13.0015 16.0472 12.7001 16.5236 12.4862C17 12.2723 17.5201 12.1654 18.084 12.1654C19.2312 12.1654 20.1986 12.5591 20.9861 13.3466C21.7736 14.1341 22.1673 15.1015 22.1673 16.2487C22.1673 16.832 22.0701 17.3668 21.8757 17.8529C21.6812 18.339 21.3895 18.7765 21.0007 19.1654L14.0007 26.1654ZM14.0007 22.8404L19.309 17.532C19.484 17.357 19.6152 17.1577 19.7027 16.9341C19.7902 16.7105 19.834 16.482 19.834 16.2487C19.834 15.782 19.6687 15.3737 19.3382 15.0237C19.0076 14.6737 18.5895 14.4987 18.084 14.4987C17.8507 14.4987 17.6416 14.5327 17.4569 14.6008C17.2722 14.6688 17.0923 14.7904 16.9173 14.9654L14.0007 17.882L11.084 14.9654C10.9673 14.8487 10.8166 14.7418 10.6319 14.6445C10.4472 14.5473 10.209 14.4987 9.91732 14.4987C9.41176 14.4987 8.99371 14.6737 8.66315 15.0237C8.3326 15.3737 8.16732 15.782 8.16732 16.2487C8.16732 16.482 8.21593 16.7008 8.31315 16.9049C8.41037 17.1091 8.53676 17.2987 8.69232 17.4737L14.0007 22.8404Z"
          fill="#616581"
        />
      </g>
    </svg>
  )
}

export const ManagerIcon = () => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3668_57442"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="29">
        <rect y="0.5" width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3668_57442)">
        <path
          d="M4.66732 24.9987C4.02565 24.9987 3.47635 24.7702 3.0194 24.3133C2.56246 23.8563 2.33398 23.307 2.33398 22.6654V9.83203C2.33398 9.19036 2.56246 8.64106 3.0194 8.18411C3.47635 7.72717 4.02565 7.4987 4.66732 7.4987H9.33398V5.16536C9.33398 4.5237 9.56246 3.97439 10.0194 3.51745C10.4763 3.0605 11.0257 2.83203 11.6673 2.83203H16.334C16.9757 2.83203 17.525 3.0605 17.9819 3.51745C18.4388 3.97439 18.6673 4.5237 18.6673 5.16536V7.4987H23.334C23.9757 7.4987 24.525 7.72717 24.9819 8.18411C25.4388 8.64106 25.6673 9.19036 25.6673 9.83203V22.6654C25.6673 23.307 25.4388 23.8563 24.9819 24.3133C24.525 24.7702 23.9757 24.9987 23.334 24.9987H4.66732ZM11.6673 7.4987H16.334V5.16536H11.6673V7.4987ZM23.334 17.9987H17.5007V20.332H10.5007V17.9987H4.66732V22.6654H23.334V17.9987ZM12.834 17.9987H15.1673V15.6654H12.834V17.9987ZM4.66732 15.6654H10.5007V13.332H17.5007V15.6654H23.334V9.83203H4.66732V15.6654Z"
          fill="#616581"
        />
      </g>
    </svg>
  )
}

export const SupervisionUserIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2578_79034"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30">
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2578_79034)">
        <path
          d="M21.25 18.75C20.375 18.75 19.6354 18.4479 19.0312 17.8438C18.4271 17.2396 18.125 16.5 18.125 15.625C18.125 14.75 18.4271 14.0104 19.0312 13.4062C19.6354 12.8021 20.375 12.5 21.25 12.5C22.125 12.5 22.8646 12.8021 23.4688 13.4062C24.0729 14.0104 24.375 14.75 24.375 15.625C24.375 16.5 24.0729 17.2396 23.4688 17.8438C22.8646 18.4479 22.125 18.75 21.25 18.75ZM15 25V23.25C15 22.75 15.1302 22.2865 15.3906 21.8594C15.651 21.4323 16.0208 21.125 16.5 20.9375C17.25 20.625 18.026 20.3906 18.8281 20.2344C19.6302 20.0781 20.4375 20 21.25 20C22.0625 20 22.8698 20.0781 23.6719 20.2344C24.474 20.3906 25.25 20.625 26 20.9375C26.4792 21.125 26.849 21.4323 27.1094 21.8594C27.3698 22.2865 27.5 22.75 27.5 23.25V25H15ZM12.5 15C11.125 15 9.94792 14.5104 8.96875 13.5312C7.98958 12.5521 7.5 11.375 7.5 10C7.5 8.625 7.98958 7.44792 8.96875 6.46875C9.94792 5.48958 11.125 5 12.5 5C13.875 5 15.0521 5.48958 16.0312 6.46875C17.0104 7.44792 17.5 8.625 17.5 10C17.5 11.375 17.0104 12.5521 16.0312 13.5312C15.0521 14.5104 13.875 15 12.5 15ZM2.5 25V21.5C2.5 20.7917 2.67708 20.1406 3.03125 19.5469C3.38542 18.9531 3.875 18.5 4.5 18.1875C5.75 17.5625 7.04688 17.0833 8.39062 16.75C9.73438 16.4167 11.1042 16.25 12.5 16.25C13.2292 16.25 13.9583 16.3125 14.6875 16.4375C15.4167 16.5625 16.1458 16.7083 16.875 16.875L14.75 19C14.375 18.8958 14 18.8281 13.625 18.7969C13.25 18.7656 12.875 18.75 12.5 18.75C11.2917 18.75 10.1094 18.8958 8.95312 19.1875C7.79688 19.4792 6.6875 19.8958 5.625 20.4375C5.41667 20.5417 5.26042 20.6875 5.15625 20.875C5.05208 21.0625 5 21.2708 5 21.5V22.5H12.5V25H2.5ZM12.5 12.5C13.1875 12.5 13.776 12.2552 14.2656 11.7656C14.7552 11.276 15 10.6875 15 10C15 9.3125 14.7552 8.72396 14.2656 8.23438C13.776 7.74479 13.1875 7.5 12.5 7.5C11.8125 7.5 11.224 7.74479 10.7344 8.23438C10.2448 8.72396 10 9.3125 10 10C10 10.6875 10.2448 11.276 10.7344 11.7656C11.224 12.2552 11.8125 12.5 12.5 12.5Z"
          fill="#616581"
        />
      </g>
    </svg>
  )
}

export const ChatIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2672_40291"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30">
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2672_40291)">
        <path
          d="M10 13.75C10.3542 13.75 10.651 13.6302 10.8906 13.3906C11.1302 13.151 11.25 12.8542 11.25 12.5C11.25 12.1458 11.1302 11.849 10.8906 11.6094C10.651 11.3698 10.3542 11.25 10 11.25C9.64583 11.25 9.34896 11.3698 9.10938 11.6094C8.86979 11.849 8.75 12.1458 8.75 12.5C8.75 12.8542 8.86979 13.151 9.10938 13.3906C9.34896 13.6302 9.64583 13.75 10 13.75ZM15 13.75C15.3542 13.75 15.651 13.6302 15.8906 13.3906C16.1302 13.151 16.25 12.8542 16.25 12.5C16.25 12.1458 16.1302 11.849 15.8906 11.6094C15.651 11.3698 15.3542 11.25 15 11.25C14.6458 11.25 14.349 11.3698 14.1094 11.6094C13.8698 11.849 13.75 12.1458 13.75 12.5C13.75 12.8542 13.8698 13.151 14.1094 13.3906C14.349 13.6302 14.6458 13.75 15 13.75ZM20 13.75C20.3542 13.75 20.651 13.6302 20.8906 13.3906C21.1302 13.151 21.25 12.8542 21.25 12.5C21.25 12.1458 21.1302 11.849 20.8906 11.6094C20.651 11.3698 20.3542 11.25 20 11.25C19.6458 11.25 19.349 11.3698 19.1094 11.6094C18.8698 11.849 18.75 12.1458 18.75 12.5C18.75 12.8542 18.8698 13.151 19.1094 13.3906C19.349 13.6302 19.6458 13.75 20 13.75ZM2.5 27.5V5C2.5 4.3125 2.74479 3.72396 3.23438 3.23438C3.72396 2.74479 4.3125 2.5 5 2.5H25C25.6875 2.5 26.276 2.74479 26.7656 3.23438C27.2552 3.72396 27.5 4.3125 27.5 5V20C27.5 20.6875 27.2552 21.276 26.7656 21.7656C26.276 22.2552 25.6875 22.5 25 22.5H7.5L2.5 27.5ZM6.4375 20H25V5H5V21.4062L6.4375 20Z"
          fill="#616581"
        />
      </g>
    </svg>
  )
}

export const pendingActionIcon = () => {
  return (
    <svg width="54" height="60" viewBox="0 0 54 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2600_28891)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.3954 54.8206V36.2365C27.3992 35.0458 27.8739 33.905 28.7158 33.063C29.5578 32.2211 30.6986 31.7464 31.8893 31.7426H49.508C50.6987 31.7464 51.8395 32.2211 52.6815 33.063C53.5234 33.905 53.9981 35.0458 54.002 36.2365V54.8206C53.9981 56.0113 53.5234 57.1521 52.6815 57.9941C51.8395 58.8361 50.6987 59.3107 49.508 59.3146H31.8893C30.6986 59.3107 29.5578 58.8361 28.7158 57.9941C27.8739 57.1521 27.3992 56.0113 27.3954 54.8206ZM28.718 5.53661L38.1741 14.3942H28.718V5.53661ZM10.0036 33.4899C9.73464 33.5049 9.48247 33.6253 9.30174 33.825C9.12102 34.0247 9.02631 34.2876 9.03816 34.5567C9.02969 34.6906 9.04812 34.8247 9.09236 34.9513C9.1366 35.0779 9.20575 35.1944 9.29574 35.2938C9.38573 35.3933 9.49472 35.4737 9.61629 35.5303C9.73786 35.5869 9.86955 35.6186 10.0036 35.6235H21.8684V33.4899H10.0036ZM10.0036 41.1311C9.73464 41.1461 9.48247 41.2665 9.30174 41.4662C9.12102 41.6659 9.02631 41.9288 9.03816 42.1979C9.02969 42.3318 9.04812 42.4659 9.09236 42.5925C9.1366 42.7191 9.20575 42.8356 9.29574 42.935C9.38573 43.0345 9.49472 43.1149 9.61629 43.1715C9.73786 43.2281 9.86955 43.2598 10.0036 43.2647H21.8684V41.1311H10.0036ZM10.0036 18.2027C9.73464 18.2177 9.48247 18.3381 9.30174 18.5378C9.12102 18.7375 9.02631 19.0004 9.03816 19.2695C9.03036 19.4032 9.04925 19.5371 9.09374 19.6634C9.13822 19.7897 9.20742 19.9059 9.29728 20.0052C9.38714 20.1045 9.49587 20.1849 9.61713 20.2418C9.73839 20.2986 9.86976 20.3307 10.0036 20.3363H20.9754C21.2443 20.3213 21.4965 20.2009 21.6772 20.0012C21.858 19.8015 21.9527 19.5386 21.9408 19.2695C21.948 19.136 21.9286 19.0023 21.8839 18.8763C21.8392 18.7503 21.7699 18.6343 21.6802 18.5352C21.5904 18.436 21.482 18.3556 21.361 18.2985C21.2401 18.2415 21.109 18.2089 20.9754 18.2027H10.0036ZM10.0036 10.5615C9.73464 10.5765 9.48247 10.6969 9.30174 10.8966C9.12102 11.0963 9.02631 11.3592 9.03816 11.6283C9.02969 11.7622 9.04812 11.8963 9.09236 12.0229C9.1366 12.1495 9.20575 12.266 9.29574 12.3654C9.38573 12.4649 9.49472 12.5453 9.61629 12.6019C9.73786 12.6585 9.86955 12.6902 10.0036 12.6951H16.0374C16.3063 12.6801 16.5585 12.5597 16.7392 12.36C16.9199 12.1603 17.0146 11.8974 17.0028 11.6283C17.0106 11.4946 16.9917 11.3607 16.9472 11.2344C16.9027 11.1081 16.8335 10.9919 16.7436 10.8926C16.6538 10.7933 16.5451 10.7129 16.4238 10.656C16.3025 10.5992 16.1712 10.5671 16.0374 10.5615H10.0036ZM10.0036 25.8488C9.73464 25.8637 9.48247 25.9841 9.30174 26.1838C9.12102 26.3836 9.02631 26.6465 9.03816 26.9155C9.03101 27.0491 9.05036 27.1827 9.09509 27.3088C9.13982 27.4348 9.20905 27.5507 9.29879 27.6499C9.38853 27.7491 9.497 27.8295 9.61796 27.8865C9.73892 27.9436 9.86997 27.9761 10.0036 27.9823H28.5587C28.8271 27.9661 29.0786 27.8453 29.2591 27.6459C29.4395 27.4465 29.5347 27.1843 29.5241 26.9155C29.5319 26.7818 29.513 26.6479 29.4685 26.5216C29.424 26.3953 29.3548 26.2791 29.265 26.1798C29.1751 26.0805 29.0664 26.0001 28.9451 25.9433C28.8238 25.8864 28.6925 25.8543 28.5587 25.8488H10.0036ZM43.4452 15.6637C43.4456 15.321 43.3341 14.9874 43.1276 14.7139C42.9211 14.4403 42.631 14.2416 42.3012 14.148L28.3559 0.579248C28.2104 0.397994 28.0259 0.251817 27.8162 0.151547C27.6064 0.0512764 27.3768 -0.000516951 27.1444 4.119e-06H2.83543C2.46356 -0.000630469 2.09521 0.0720662 1.75147 0.213935C1.40773 0.355803 1.09533 0.564058 0.832154 0.826785C0.568979 1.08951 0.360191 1.40155 0.217736 1.74505C0.0752822 2.08856 0.00195759 2.45678 0.00195813 2.82864V51.2872C0.00125683 51.6594 0.0742617 52.028 0.216761 52.3718C0.35926 52.7157 0.568431 53.0279 0.832208 53.2904C1.36542 53.8183 2.08512 54.1148 2.83543 54.1159H21.9119V50.9541H3.16366V3.16654H25.5563V15.9678C25.5563 16.389 25.7236 16.7929 26.0214 17.0908C26.3192 17.3886 26.7232 17.5559 27.1444 17.5559H40.2739V27.9099H43.4452V15.6637ZM36.6295 43.284L38.932 45.4465L44.4106 39.8761C44.8933 39.3934 45.2071 38.9879 45.8105 39.6058L47.7413 41.6042C48.3833 42.2365 48.3495 42.6082 47.7413 43.1971L40.0663 50.7997C38.792 52.0499 39.0092 52.1271 37.7204 50.8383L33.376 46.494C33.3136 46.4372 33.2646 46.3671 33.2328 46.2889C33.201 46.2106 33.1871 46.1263 33.1922 46.042C33.1973 45.9577 33.2212 45.8756 33.2622 45.8018C33.3032 45.728 33.3603 45.6643 33.4291 45.6155L35.6978 43.2647C36.0406 42.9123 36.3109 42.9364 36.6633 43.2647L36.6295 43.284Z"
          fill="#616581"
        />
      </g>
      <defs>
        <clipPath id="clip0_2600_28891">
          <rect width="54" height="59.3146" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const sortingIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_6476_5804" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6476_5804)">
        <path
          d="M8 14.6654L4 10.6654L4.95 9.71536L8 12.7654L11.05 9.71536L12 10.6654L8 14.6654ZM4.96667 6.26536L4 5.33203L8 1.33203L12 5.33203L11.0333 6.26536L8 3.23203L4.96667 6.26536Z"
          fill="#151515"
        />
      </g>
    </svg>
  )
}
export const FailedIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.40039 15.375L9.00127 2.25L16.6021 15.375H1.40039ZM3.33877 14.25H14.6638L9.00127 4.5L3.33877 14.25ZM9.00127 13.3558C9.17289 13.3558 9.31677 13.2978 9.43289 13.1816C9.54902 13.0655 9.60708 12.9216 9.60708 12.75C9.60708 12.5784 9.54902 12.4345 9.43289 12.3184C9.31677 12.2023 9.17289 12.1442 9.00127 12.1442C8.82964 12.1442 8.68577 12.2023 8.56964 12.3184C8.45352 12.4345 8.39545 12.5784 8.39545 12.75C8.39545 12.9216 8.45352 13.0655 8.56964 13.1816C8.68577 13.2978 8.82964 13.3558 9.00127 13.3558ZM8.43877 11.3942H9.56377V7.64419H8.43877V11.3942Z"
      fill="#FF2929"
    />
  </svg>
)

export const HomeIcon = ({ width = 16, height = 16, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
    <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  </svg>
)

export const DocupdateIcon = ({ color }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.8 7.8L5.5 7.075L4.425 6L5.5 4.925L4.8 4.2L3 6L4.8 7.8ZM7.2 7.8L9 6L7.2 4.2L6.5 4.925L7.575 6L6.5 7.075L7.2 7.8ZM2.5 10.5C2.225 10.5 1.98958 10.4021 1.79375 10.2063C1.59792 10.0104 1.5 9.775 1.5 9.5V2.5C1.5 2.225 1.59792 1.98958 1.79375 1.79375C1.98958 1.59792 2.225 1.5 2.5 1.5H4.6C4.70833 1.2 4.88958 0.958333 5.14375 0.775C5.39792 0.591667 5.68333 0.5 6 0.5C6.31667 0.5 6.60208 0.591667 6.85625 0.775C7.11042 0.958333 7.29167 1.2 7.4 1.5H9.5C9.775 1.5 10.0104 1.59792 10.2063 1.79375C10.4021 1.98958 10.5 2.225 10.5 2.5V9.5C10.5 9.775 10.4021 10.0104 10.2063 10.2063C10.0104 10.4021 9.775 10.5 9.5 10.5H2.5ZM2.5 9.5H9.5V2.5H2.5V9.5ZM6 2.125C6.10833 2.125 6.19792 2.08958 6.26875 2.01875C6.33958 1.94792 6.375 1.85833 6.375 1.75C6.375 1.64167 6.33958 1.55208 6.26875 1.48125C6.19792 1.41042 6.10833 1.375 6 1.375C5.89167 1.375 5.80208 1.41042 5.73125 1.48125C5.66042 1.55208 5.625 1.64167 5.625 1.75C5.625 1.85833 5.66042 1.94792 5.73125 2.01875C5.80208 2.08958 5.89167 2.125 6 2.125Z" fill={color} />
  </svg>
)
